/* eslint-disable no-underscore-dangle */
/**
 * Exposes the FOSJSRouting bundle Router and wraps its generate function to always inject the current locale
 *
 * @module Router
 */

const locale = document.querySelector('html').getAttribute('lang').replace('-', '_');
const originalGenerate = window.Routing.generate;

window.Routing.generate = function patchedGenerate(name, params = {}, absolute = false) {
    const enhancedParams = {
        _locale: locale,
        ...params,
    };

    return originalGenerate.call(this, name, enhancedParams, absolute);
};

export default window.Routing;
